import { render, staticRenderFns } from "./Mensagem.vue?vue&type=template&id=771998a1&scoped=true&"
import script from "./Mensagem.vue?vue&type=script&lang=js&"
export * from "./Mensagem.vue?vue&type=script&lang=js&"
import style0 from "./Mensagem.vue?vue&type=style&index=0&id=771998a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771998a1",
  null
  
)

export default component.exports